import type { IModuleStringsProviderProps } from './IModuleStringsProviderProps';
import { ModuleStringsContext } from './ModuleStringsContext';

/** Надає резолвер рядків модуля піддереву: рендерять RecordListBody, RecordPage і ModuleMenu навколо своїх дерев. */
export function ModuleStringsProvider({ strings, children }: IModuleStringsProviderProps) {
  return <ModuleStringsContext.Provider value={strings}>{children}</ModuleStringsContext.Provider>;
}
